<template>
  <div class="container">
    <div class="component-block">
      <div class="component-main">
        <div class="kind">
          <h1>微信快速裂变</h1>
          <p>软性广告快速裂变<br>
            刷屏朋友圈带来高效曝光</p>
          <hr>
        </div>
        <div class="kind">
          <h1>跑团邦携手国内上百场顶级赛事<br>
            让企业品牌刷爆整个互联网</h1>
          <hr>
        </div>
        <div class="kind">
          <h1>自媒体软文植入</h1>
          <p>微信公众号、头条号、搜狐号等各大流量自媒体<br>
            软文植入,获得品牌曝光。</p>
          <hr>
        </div>
        <div class="kind">
          <h1>微博传播曝光</h1>
          <p>跑友口碑宣传，分享传播</p>
          <hr>
        </div>
        <img src="../../../assets/images/phone.png">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Online'
}
</script>

<style scoped lang="stylus">
  .container
    .component-block
      width: 100%
      background-color: #eeeeee
      background-image: url("../../../assets/images/advantage-first-gray-bg.png")
      background-position: center
      background-size: cover
      .component-main
        width: 1300px
        height: 695px
        margin: 0 auto
        position: relative
        img
          height: 686px
          position: absolute
          left: 492px
          top: 189px
        .kind
          display: inline-block
          text-align: center
          position: absolute
          h1
              font-size: 26px
              font-weight: 400
              border: 4px dashed #aaaaaa
              display: inline-block
              padding: 9px 19px
          p
            margin: 0
            font-size: 20px
            font-weight: 400
            color: #aaaaaa
            line-height: 27px
          &:first-child
            left: 133px
            top: 120px
            hr
              width: 171px;
              transform: rotate(28deg);
              -ms-transform: rotate(28deg);
              -moz-transform: rotate(28deg);
              -webkit-transform: rotate(28deg);
              -o-transform: rotate(28deg);
              left: 221px;
              top: 88px;
          &:nth-child(2)
            right: 10px
            top: 173px
            hr
              width: 193px;
              transform: rotate(-30deg);
              -ms-transform: rotate(-30deg);
              -moz-transform: rotate(-30deg);
              -webkit-transform: rotate(-30deg);
              -o-transform: rotate(-30deg);
              right: 220px;
              top: 155px;
          &:nth-child(3)
            left: 73px
            top: 490px
            hr
              width: 128px;
              transform: rotate(-34deg);
              -ms-transform: rotate(-34deg);
              -moz-transform: rotate(-34deg);
              -webkit-transform: rotate(-34deg);
              -o-transform: rotate(-34deg);
              left: 331px;
              top: 0px;
          &:nth-child(4)
            right: 100px
            top: 492px
            hr
              width: 102px;
              transform: rotate(31deg);
              -ms-transform: rotate(31deg);
              -moz-transform: rotate(31deg);
              -webkit-transform: rotate(31deg);
              -o-transform: rotate(31deg);
              right: 215px;
              top: 15px;
          hr
            position: absolute
            border: 2px dashed #aaaaaa
</style>



// WEBPACK FOOTER //
// src/pages/advantage/components/Online.vue